export default "__VITE_ASSET__e5ad8d48__"